module.exports = __webpack_public_path__ + "static/media/United_transparent_white.2e7dde45.png";